import { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';

const navItems = [
  { label: '首页', to: '/' },
  { label: '赛事', to: '/category/all' },
  { label: '球队', to: '/teams' },
  { label: '球员', to: '/players' },
  { label: '新闻', to: '/news' },
  { label: '关于', to: '/about' },
];

export default function Navbar() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : '/search');
    setMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="px-4 md:px-6 h-16 flex items-center gap-4 md:gap-8">
        <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
          <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center text-background-50">
            <i className="ri-basketball-line text-xl"></i>
          </span>
          <span className="font-heading font-extrabold text-lg md:text-xl text-foreground-950 tracking-tight">
            篮球比分
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1 lg:gap-2">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `px-3 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  isActive ? 'text-primary-600 bg-primary-50' : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form onSubmit={submitSearch} className="hidden md:flex items-center ml-auto">
          <div className="relative">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm flex items-center justify-center w-4 h-4">
              <i className="ri-search-line"></i>
            </span>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索赛事 / 球队 / 球员"
              className="w-52 lg:w-72 h-10 pl-9 pr-3 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
            />
          </div>
        </form>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className="md:hidden ml-auto w-10 h-10 flex items-center justify-center rounded-md border border-background-200 text-foreground-800 cursor-pointer"
        >
          <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-4 space-y-3">
          <form onSubmit={submitSearch} className="relative">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm flex items-center justify-center w-4 h-4">
              <i className="ri-search-line"></i>
            </span>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索赛事 / 球队 / 球员"
              className="w-full h-11 pl-9 pr-3 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
            />
          </form>
          <nav className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-2.5 rounded-md text-sm font-medium text-center transition-colors cursor-pointer ${
                    isActive ? 'text-primary-600 bg-primary-50' : 'text-foreground-700 bg-background-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}